import React, { useEffect, useState } from "react";
import {
  DataGridPro,
  GridToolbarContainer,
  LicenseInfo,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import { GridActionsCellItem } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _, { get, isEmpty, includes, filter } from "lodash/fp";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Typography, Tooltip } from "@material-ui/core";
import { Delete, Edit, FactCheck, Gavel } from "@mui/icons-material";
import { useHistory } from "react-router";

import { ADMIN } from "../../../../consts/roles";
import { getArbitratorConflictGridCell } from "../../../../utils/arbitratorUtils";
import TeamName, { teamNameTextOnly } from "components/team/TeamName";
import { CustomTooltip } from "../../../helpers";
import { runPairing, deletePairing } from "../../../../actions/adminActions";
import { Button } from "@mui/material";
import { getCurrentMoot } from "../../../../reducers/mootSelectors";
import InfoIcon from "@mui/icons-material/Info";
import * as adminSelectors from "../../../../reducers/adminSelectors";
import { getCompleteOralArgumentSchedule } from "../../../../reducers/adminSelectors";

LicenseInfo.setLicenseKey(
  "19a99a1195c5f52fabd5f3310b083226T1JERVI6Mjk5MzAsRVhQSVJZPTE2NjQxNDA4NTIwMDAsS0VZVkVSU0lPTj0x",
);

const ScheduleTable = ({
  user = {},
  moot,
  dateFilter,
  runPairing = _.noop,
  oralArgumentSchedule,
  allArbitrators,
  getSelectedRoundSchedule = _.noop,
  deletePairing = _.noop,
  getOralArgumentSchedule = _.noop,
}) => {
  const history = useHistory();

  const [isLoading, setIsLoading] = React.useState(false);
  const [pairingButtonEnabled, setPairingButtonEnabled] = React.useState(
    !moot?.arbitratorPairingsAreBeingGenerated,
  );

  const onEdit = (pairingId) => {
    history.push(`/admin/oral-arguments/edit/${pairingId}`);
  };
  const onCreate = () => {
    history.push(`/admin/oral-arguments/new`);
  };
  const onInputScores = (pairingId) => {
    history.push(`/admin/oral-arguments/score/${pairingId}`);
  };
  const onReviewScores = (pairingId) => {
    history.push(`/admin/oral-arguments/review-score/${pairingId}`);
  };

  const [selectedRoundSchedule, setSelectedRoundSchedule] = useState(false);
  useEffect(() => {
    const asyncFetchData = async () => {
      const result = getSelectedRoundSchedule();
      setSelectedRoundSchedule(result);
    };
    asyncFetchData();
  }, [oralArgumentSchedule]);

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer
        style={{ justifyContent: "space-between", alignContent: "center" }}
      >
        <div>
          <GridToolbarColumnsButton className="toolbar-button" />
          <GridToolbarFilterButton className="toolbar-button" />
          <GridToolbarDensitySelector className="toolbar-button" />
          <GridToolbarExport
            className="toolbar-button"
            printOptions={{ disableToolbarButton: true }}
            csvOptions={{
              fileName: `General Round Schedule - ${format(new Date(), "yyyy-MM-dd")}`,
              utf8WithBom: true,
            }}
          />
        </div>
        <div>
          <Typography
            style={{
              margin: "-2px 0 0",
              padding: "2px 0.25rem",
              textAlign: "left",
              fontSize: "11px",
              color: "#000000",
              backgroundColor: `${moot.showOralDetailsTeamOpenDate.notYetOpen === true ? "#FFFF8A" : "#B9E9C9"}`,
            }}
          >
            General Rounds schedule{" "}
            <strong>
              {moot.showOralDetailsTeamOpenDate.notYetOpen === true
                ? "is not"
                : "is"}{" "}
            </strong>{" "}
            visible to Teams.
          </Typography>
          {/*
                <Typography style={{margin:'-2px 0 0 4px', padding:'2px 0.25rem', textAlign:'left', fontSize:'11px', color:'#000000', backgroundColor:`${moot.showOralDetailsArbitratorsOpenDate.notYetOpen === true ? '#FFFF8A' : '#B9E9C9'}`}}>General Rounds schedule <strong>{moot.showOralDetailsArbitratorsOpenDate.notYetOpen === true ? 'is not' : 'is'} </strong> visible to Arbitrators.
                </Typography>
                 */}
        </div>
        <div>
          {includes(ADMIN, user.roles) && (
          <>
          <Button
            style={{
              margin: "0 2rem 0 0",
            }}
            color="primary"
            size="small"
            disabled={!pairingButtonEnabled}
            title=""
            onClick={() => onCreate()}
          >
            Add pairing
          </Button>    
          <Button
            color="primary"
            size="small"
            disabled={!pairingButtonEnabled}
            title=""
            onClick={async (e) => {
              e.preventDefault();
              const result = window.confirm(
                `This will replace all arbitrator pairings. Are you sure you want to continue?`,
              );
              if (result) {
                try {
                  setIsLoading(true);
                  //fire and forget because this takes a long time
                  runPairing();
                } finally {
                  setIsLoading(false);
                  setPairingButtonEnabled(false);
                }
              }
            }}
          >
            {pairingButtonEnabled
              ? "Pair Arbitrators"
              : "Generating Arbitrator Pairings"}
          </Button>
          </>
          )}
          {!pairingButtonEnabled && (
            <span>
              <Tooltip title="The arbitrator pairing process may take a few minutes to run. An email notification will be sent to the admins upon pairing completion.">
                <InfoIcon sx={{ fontSize: 14, transform: "translateY(2px)" }} />
              </Tooltip>
            </span>
          )}
        </div>
      </GridToolbarContainer>
    );
  };

  const getArbitratorRecord = (arbitrator) => {
    const arbWithSchedule = _.find(
      (a) => arbitrator.id === a.id,
      allArbitrators,
    );

    return {
      ...arbitrator,
      schedule: arbWithSchedule?.schedule,
    };
  };
  const columns = [
    {
      field: "id",
      headerName: "Id",
      align: "right",
      flex: 1,
      hide: true,
    },
    {
      field: "claimantId",
      headerName: "Claimant Id",
      align: "right",
      flex: 1,
      hide: true,
    },
    {
      field: "claimant",
      headerName: "Claimant",
      flex: 1,
      renderCell: (params) => (
        <TeamName team={params.row.claimant} adminUse={true} />
      ),
      valueGetter: (params) =>
        params.row.claimant?.hideTeamName === true
          ? `TEAM ID ${params.row.claimant?.id}`
          : params.row.claimant?.school,
    },
    {
      field: "claimantPractice",
      headerName: "Claimant Practice?",
      flex: 1,
      hide: true,
      valueGetter: (params) => params.row.claimantPractice,
    },
    {
      field: "respondentId",
      headerName: "Respondent Id",
      align: "right",
      flex: 1,
      hide: true,
    },
    {
      field: "respondent",
      headerName: "Respondent",
      flex: 1,
      renderCell: (params) => (
        <TeamName team={params.row.respondent} adminUse={true} />
      ),
      valueGetter: (params) =>
        params.row.respondent?.hideTeamName === true
          ? `TEAM ID ${params.row.respondent?.id}`
          : params.row.respondent?.school,
    },
    {
      field: "respondentPractice",
      headerName: "Respondent Practice?",
      flex: 1,
      hide: true,
      valueGetter: (params) => params.row.respondentPractice,
    },
    {
      field: "pairingDate",
      headerName: "Date HKT",
      align: "right",
      width: 130,
      renderCell: (params) =>
        format(
          utcToZonedTime(params.row.pairingTime, "Asia/Hong_Kong"),
          "iii, dd MMMM",
        ),
      valueGetter: (params) =>
        format(
          utcToZonedTime(params.row.pairingTime, "Asia/Hong_Kong"),
          "yyyy/MM/dd",
        ),
    },
    {
      field: "pairingTime",
      headerName: "Time HKT",
      align: "right",
      width: 100,
      valueGetter: (params) =>
        format(
          utcToZonedTime(params.row.pairingTime, "Asia/Hong_Kong"),
          "hh:mm aaa",
        ),
    },
    {
      field: "pairingDateTime",
      headerName: "Date & Time HKT",
      align: "right",
      flex: 1,
      hide: true,
      valueGetter: (params) =>
        format(
          utcToZonedTime(params.row.pairingTime, "Asia/Hong_Kong"),
          "yyyy/MM/dd HH:mm",
        ),
    },
    {
      field: "hearingLink",
      headerName: "Virtual Hearing Link",
      flex: 1,
      hide: true,
      sortable: false,
      renderCell: (params) => {
        if (!params.row.hearingLink) {
          return <span>coming soon</span>;
        } else {
          return (
            <a
              target="_blank"
              rel="noreferrer"
              href={`${params.row.hearingLink}`}
            >
              Click Here
            </a>
          );
        }
      },
    },
    {
      field: "room",
      headerName: "Room",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        if (!get("row.room", params)) {
          return <CustomTooltip content="available at check-in" />;
        } else {
          return <CustomTooltip content={params.row.room} />;
        }
      },
    },
    {
      field: "chairArbitratorId",
      headerName: "First Arbitrator Id",
      align: "right",
      flex: 1,
      hide: true,
      valueGetter: (params) => `${params.row.chairArbitrator?.id ?? ""}`,
    },
    {
      field: "chairArbitrator",
      headerName: "First Arbitrator",
      flex: 1,
      valueGetter: (params) =>
        `${params.row.chairArbitrator?.firstName ?? ""} ${params.row.chairArbitrator?.lastName ?? ""}`.trim(),
      renderCell: (params) =>
        getArbitratorConflictGridCell(
          params.row.claimant,
          params.row.respondent,
          getArbitratorRecord(params.row?.chairArbitrator),
          params.row.pairingTime,
          oralArgumentSchedule,
          params.row.id,
        ),
    },
    {
      field: "secondArbitratorId",
      headerName: "Second Arbitrator Id",
      align: "right",
      flex: 1,
      hide: true,
      valueGetter: (params) => `${params.row.secondArbitrator?.id ?? ""}`,
    },
    {
      field: "secondArbitrator",
      headerName: "Second Arbitrator",
      flex: 1,
      valueGetter: (params) =>
        `${params.row.secondArbitrator?.firstName ?? ""} ${params.row.secondArbitrator?.lastName ?? ""}`.trim(),
      renderCell: (params) =>
        getArbitratorConflictGridCell(
          params.row.claimant,
          params.row.respondent,
          getArbitratorRecord(params.row?.secondArbitrator),
          params.row.pairingTime,
          oralArgumentSchedule,
          params.row.id,
        ),
    },
    {
      field: "thirdArbitratorId",
      headerName: "Third Arbitrator Id",
      align: "right",
      flex: 1,
      hide: true,
      valueGetter: (params) => `${params.row.thirdArbitrator?.id ?? ""}`,
    },
    {
      field: "thirdArbitrator",
      headerName: "Third Arbitrator",
      flex: 1,
      valueGetter: (params) =>
        `${params.row.thirdArbitrator?.firstName ?? ""} ${params.row.thirdArbitrator?.lastName ?? ""}`.trim(),
      renderCell: (params) =>
        getArbitratorConflictGridCell(
          params.row.claimant,
          params.row.respondent,
          getArbitratorRecord(params.row?.thirdArbitrator),
          params.row.pairingTime,
          oralArgumentSchedule,
          params.row.id,
        ),
    },
    {
      field: "firstReserveArbitratorId",
      headerName: "First Reserve Id",
      align: "right",
      flex: 1,
      hide: true,
      valueGetter: (params) => `${params.row.firstReserveArbitrator?.id ?? ""}`,
    },
    {
      field: "firstReserveArbitrator",
      headerName: "First Reserve",
      flex: 1,
      hide: true,
      valueGetter: (params) =>
        `${params.row.firstReserveArbitrator?.firstName ?? ""} ${params.row.firstReserveArbitrator?.lastName ?? ""}`.trim(),
      renderCell: (params) =>
        getArbitratorConflictGridCell(
          params.row.claimant,
          params.row.respondent,
          getArbitratorRecord(params.row?.firstReserveArbitrator),
          params.row.pairingTime,
          oralArgumentSchedule,
          params.row.id,
        ),
    },
    {
      field: "secondReserveArbitratorId",
      headerName: "Second Reserve Id",
      align: "right",
      flex: 1,
      hide: true,
      valueGetter: (params) =>
        `${params.row.secondReserveArbitrator?.id ?? ""}`,
    },
    {
      field: "secondReserveArbitrator",
      headerName: "Second Reserve",
      flex: 1,
      hide: true,
      valueGetter: (params) =>
        `${params.row.secondReserveArbitrator?.firstName ?? ""} ${params.row.secondReserveArbitrator?.lastName ?? ""}`.trim(),
      renderCell: (params) =>
        getArbitratorConflictGridCell(
          params.row.claimant,
          params.row.respondent,
          getArbitratorRecord(params.row?.secondReserveArbitrator),
          params.row.pairingTime,
          oralArgumentSchedule,
          params.row.id,
        ),
    },
    {
      field: "thirdReserveArbitratorId",
      headerName: "Third Reserve Id",
      align: "right",
      flex: 1,
      hide: true,
      valueGetter: (params) => `${params.row.thirdReserveArbitrator?.id ?? ""}`,
    },
    {
      field: "thirdReserveArbitrator",
      headerName: "Third Reserve",
      flex: 1,
      hide: true,
      valueGetter: (params) =>
        `${params.row.thirdReserveArbitrator?.firstName ?? ""} ${params.row.thirdReserveArbitrator?.lastName ?? ""}`.trim(),
      renderCell: (params) =>
        getArbitratorConflictGridCell(
          params.row.claimant,
          params.row.respondent,
          getArbitratorRecord(params.row?.thirdReserveArbitrator),
          params.row.pairingTime,
          oralArgumentSchedule,
          params.row.id,
        ),
    },
    {
      field: "claimantScore",
      headerName: "Claimant Score",
      align: "right",
      width: 130,
      valueGetter: (params) => {
        const score = params.row.PairingScore;
        if (isEmpty(score)) return 0;
        return (
          score.firstClaimantChairScore +
          score.firstClaimantArb1Score +
          score.firstClaimantArb2Score +
          score.secondClaimantChairScore +
          score.secondClaimantArb1Score +
          score.secondClaimantArb2Score
        );
      },
    },
    {
      field: "respondentScore",
      headerName: "Respondent Score",
      align: "right",
      width: 130,
      valueGetter: (params) => {
        const score = params.row.PairingScore;
        if (isEmpty(score)) return 0;
        return (
          score.firstRespondentChairScore +
          score.firstRespondentArb1Score +
          score.firstRespondentArb2Score +
          score.secondRespondentChairScore +
          score.secondRespondentArb1Score +
          score.secondRespondentArb2Score
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Action",
      flex: 1,
      getActions: (params) => [
        <GridActionsCellItem
          label="Edit"
          onClick={() => onEdit(params.row.id)}
          disabled={!includes(ADMIN, user.roles)}
          icon={
            <Tooltip title="Edit">
              <Edit />
            </Tooltip>
          }
        />,
        <GridActionsCellItem
          label="Input Scores"
          onClick={() => onInputScores(params.row.id)}
          icon={
            <Tooltip title="Input Scores">
              <Gavel />
            </Tooltip>
          }
        />,
        <GridActionsCellItem
          label="Review Scores"
          onClick={() => onReviewScores(params.row.id)}
          icon={
            <Tooltip title="Review Scores">
              <FactCheck />
            </Tooltip>
          }
        />,
      ],
    },
    {
      field: "delete",
      hide: true,
      type: "actions",
      headerName: "Delete",
      getActions: (params) => [
        <GridActionsCellItem
          icon={
            <Tooltip title="Delete">
              <Delete />
            </Tooltip>
          }
          onClick={async () => {
            const result = window.confirm(
              `This will permanently delete the pairing record and any scores associated for ${teamNameTextOnly(params.row?.claimant)} vs ${teamNameTextOnly(params.row?.respondent)}. Are you sure you want to continue?`,
            );
            if (result) {
              try {
                setIsLoading(true);
                await deletePairing(params.row.id);
                await getOralArgumentSchedule(true);
              } finally {
                setIsLoading(false);
              }
            }
          }}
          label="Delete"
          disabled={!includes(ADMIN, user.roles)}
        />,
      ],
    },
  ];

  const getFilteredSchedule = (selectedRoundSchedule, dateFilter) => {
    if (isEmpty(dateFilter) || dateFilter === "All") {
      return selectedRoundSchedule;
    }
    return filter(
      (s) =>
        format(utcToZonedTime(s.pairingTime, "Asia/Hong_Kong"), "EEEE") ===
        dateFilter,
      selectedRoundSchedule,
    );
  };

  return (
    <div style={{ height: 700, width: "100%" }}>
      <DataGridPro
        rows={getFilteredSchedule(selectedRoundSchedule, dateFilter)}
        columns={columns}
        disableSelectionOnClick
        initialState={{
          sorting: {
            sortModel: [{ field: "pairingDateTime", sort: "asc" }],
          },
        }}
        loading={isLoading}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
    </div>
  );
};

export default connect(
  (state, ownProps) => ({
    user: state.user,
    currentMoot: state.moot.currentMoot,
    dateFilter: ownProps.dateFilter,
    oralArgumentSchedule: ownProps.oralArgumentSchedule,
    allArbitrators: ownProps.allArbitrators,
    onPairingDeleted: ownProps.onPairingDeleted,
  }),
  {
    runPairing,
    getCurrentMoot,
    getSelectedRoundSchedule: adminSelectors.getSelectedRoundSchedule,
    getOralArgumentSchedule: getCompleteOralArgumentSchedule,
    deletePairing,
  },
)(ScheduleTable);
